import { gql } from '@apollo/client';
import { CONTENT_BLOCK } from '../content';
import { IMAGE_BLOCK } from '../image';
import { LISTS_BLOCK } from '../lists';
import { BLOCK_SETTINGS_FIELD } from '../../fields';
import { FORM_BLOCK } from '../form';

export const CARD_WITH_BLOCKS = gql`
  fragment CardWithBlocksFragment on CardWithBlocks {
    blockSettings {
      ...BlockSettingsFieldFragment
    }
    color
    hasBorder
    blocks {
      ...ContentBlockFragment
      ...ImageBlockFragment
      ...ListsBlockFragment
      ...FormBlockFragment
    }
    id
    blockName
    blockType
  }
  ${BLOCK_SETTINGS_FIELD}
  ${CONTENT_BLOCK}
  ${IMAGE_BLOCK}
  ${LISTS_BLOCK}
  ${FORM_BLOCK}
`;
